import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { openAiChat } from '@euler/app/flows/ai-suite/openAiChat';
import { aiSuiteToolForFeature } from '@euler/app/flows/ai-suite/theme';
import { FeatureNotEnabledView } from '@euler/components/entitlements/FeatureNotEnabledView';
import { useStoreFeature } from '@euler/functions/entitlements/useStoreFeature';
import { useIsMobileLayout } from '@euler/functions/responsiveness';
import { useUserProfileInfo } from '@euler/functions/user/useUserProfileInfo';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { AiHomeFeature } from '@euler/model/ai-home';
import { StoreFeature } from '@euler/model/enum';
import { Text } from 'react-native';
import { useAnimatedAfterInstant } from './functions/useAnimatedAfterInstant';
import { BiDashboardListView } from './list/BiDashboardListView';

function BiDashboardList({ instant }: BiDashboardListPageParams) {
  const navigation = useAppNavigation();
  useAnimatedAfterInstant(instant);
  const mobile = useIsMobileLayout();
  return (
    <BiDashboardListView
      mobile={mobile}
      onBack={() => navigation.goBack()}
      // `navigate`, not `push`: from the picker's 管理全部看板 it returns to
      // the dashboard beneath with the one picked, so history stays flat.
      onOpen={dashboardId =>
        navigation.navigate('BiDashboard', { dashboardId })
      }
      onOpenLibrary={() => navigation.navigate('BiDatasets', {})}
      onOpenExports={() => navigation.navigate('BiExports', {})}
      onAskAi={() =>
        openAiChat(navigation, {
          kind: 'new',
          tool: aiSuiteToolForFeature(AiHomeFeature.BusinessIntelligence),
        })
      }
    />
  );
}

export interface BiDashboardListPageParams {
  /** Opened in place of the BI entry: shown without a transition. */
  instant?: boolean;
}

export const BiDashboardListPage = wrapNavigatorScreen(
  ({ instant }: BiDashboardListPageParams) => {
    const profile = useUserProfileInfo();
    const bi = useStoreFeature(StoreFeature.Bi);
    if (!bi.enabled) return <FeatureNotEnabledView feature={StoreFeature.Bi} />;
    if (!profile?.user.enabled)
      return <Text>当前门店尚未开通经营分析，或账号不可用。</Text>;
    return (
      <BiDashboardList
        key={`${profile.org.id}:${profile.store.id}`}
        instant={instant}
      />
    );
  },
  ({ route }) => ({
    title: '数据看板',
    headerShown: false,
    headerMode: 'float',
    animationEnabled: !route.params?.instant,
  }),
);
